/**
 * Creates a cross-browser compatible DOM Event with the given name.
 * Falls back to the legacy `document.createEvent` API for browsers that do not support the `Event` constructor.
 */
export const createEvent = (eventName: string) => {
    let event;
    if (typeof Event === 'function') {
        event = new Event(eventName);
    } else {
        event = document.createEvent('Event');
        event.initEvent(eventName, true, true);
    }

    return event;
};
